var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#16635F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4691 5.54501H10.8729C10.839 5.45235 10.8019 5.36133 10.7617 5.27206C11.2937 4.60081 12.138 4.16699 13.0887 4.16699C14.6559 4.16699 15.9342 5.34603 16.0004 6.82422L16.0031 6.94471H17.7517C18.0736 6.94471 18.3346 7.19344 18.3346 7.50026V15.2779C18.3346 15.5847 18.0736 15.8334 17.7517 15.8334H13.3717C13.423 15.6596 13.4509 15.4737 13.4509 15.2781V14.7223H17.1688V8.0558H13.4509V7.50053C13.4509 7.30473 13.4229 7.11866 13.3715 6.94471H14.8373C14.8373 6.02426 14.0544 5.27808 13.0887 5.27808C12.6872 5.27808 12.3173 5.40706 12.0221 5.62392C11.8439 5.5723 11.6578 5.54501 11.4691 5.54501ZM13.4509 11.3624V10.2233C13.891 10.0863 14.2159 9.70644 14.2512 9.24981L14.2544 9.16689C14.2544 8.86007 14.5154 8.61134 14.8373 8.61134C15.1592 8.61134 15.4202 8.86007 15.4202 9.16689C15.4202 10.2768 14.5665 11.1966 13.4509 11.3624Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9129 11.3896C5.62524 11.3896 4.58139 10.3947 4.58139 9.16738C4.58139 8.86056 4.84235 8.61183 5.16426 8.61183C5.48618 8.61183 5.74714 8.86056 5.74714 9.16738C5.74714 9.78101 6.26907 10.2785 6.9129 10.2785C7.52747 10.2785 8.03096 9.82521 8.07546 9.2503L8.07866 9.16738C8.07866 8.86056 8.33962 8.61183 8.66154 8.61183C8.98345 8.61183 9.24442 8.86056 9.24442 9.16738C9.24442 10.3947 8.20056 11.3896 6.9129 11.3896Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8246 6.82471C9.75841 5.34652 8.48012 4.16748 6.9129 4.16748C5.30333 4.16748 3.99851 5.41111 3.99851 6.9452H2.24987C1.92796 6.9452 1.66699 7.19393 1.66699 7.50074V15.2784C1.66699 15.5852 1.92796 15.8339 2.24987 15.8339H11.5759C11.8978 15.8339 12.1588 15.5852 12.1588 15.2784V7.50074C12.1588 7.19393 11.8978 6.9452 11.5759 6.9452H9.82729L9.8246 6.82471ZM8.66154 6.9452C8.66154 6.02475 7.87865 5.27857 6.9129 5.27857C5.98165 5.27857 5.22042 5.9724 5.16723 6.84727L5.16426 6.9452H8.66154ZM10.9931 14.7228V8.05629H2.83275V14.7228H10.9931Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleBag);
export default __webpack_public_path__ + "static/media/multipleBag.b01b2afa.svg";
export { ForwardRef as ReactComponent };